var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalmon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92555;}\n\t.st1{fill:#EF9062;}\n\t.st2{fill:#F7B9AA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.92,184.34c42.72,0,77.36-34.32,77.36-76.66c0-42.34-34.63-76.66-77.36-76.66s-77.36,34.32-77.36,76.66 C26.57,150.02,61.2,184.34,103.92,184.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.48,114.02c-5.99-1.35-11.61-4.3-16.11-8.47c-0.22-0.2-0.45-0.44-0.47-0.74 c-0.02-0.42,0.37-0.72,0.72-0.95c3.33-2.14,19.21-13.4,22.07-9.48c1.36,1.86-0.52,7.08-0.87,9.08 C122.19,107.06,122.84,115.23,117.48,114.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.62,78.23c-0.54,0.04-4.1,0.75-4.1,0.75s1.63,2.79,2.41,4.35c-0.91,0.74-1.82,1.47-2.72,2.21 c0.97,0.06,1.91,0.62,2.41,1.46c-1.5,1.27-2.88,2.68-4.12,4.2c6.18-1.9,12.87-2.15,19.18-0.7c0.76,0.17,1.55,0.37,2.31,0.18 c0.44-0.11,0.84-0.36,1.23-0.59c4.88-2.98,15.36-6.96,18.22-11.66c-3.62-2.33-10.24-1.18-14.32-1.12 C82.28,77.41,75.44,77.72,68.62,78.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.95,83.65c2.76-2.42,5.52-5.13,6.53-8.65c-3.83,2.12-7.67,4.24-11.5,6.36c-0.45-3.96,1.98-8.08,5.66-9.61 c-12.58-6.29-27.73-6.47-41.06-1.99s-24.93,13.3-34.16,23.91c-2.91,3.34-5.64,6.93-7.27,11.05c-2.84,7.19-4.77,24.54,2.96,29.63 c5.5,3.62,7.29-1.75,8.66-6.06c2.26-7.1,4.58-11.51,11.83-14.37c9.83-3.88,19.96-6.31,29.51-11.02 C127.51,97.77,137.23,91.29,145.95,83.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.14,161.66c-13.38-7.29-25.84-24.58-25.55-40.27c0.07-3.72,0.4-7.43,0.99-11.1 c0.76-4.74,2.16-9.74,5.87-12.79c-2.02,11.77,1.37,27.27,15.46,28.86c5.98,0.67,12.42-2.54,14.8-8.08 c2.17,3.63,1.67,8.44-0.51,12.07c-2.18,3.63-5.79,6.2-9.63,7.97C90.53,145.99,90.03,154.28,87.14,161.66z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalmon);
export default __webpack_public_path__ + "static/media/Salmon.36b820b251caf73f65ef40a27728b19d.svg";
export { ForwardRef as ReactComponent };